<template lang="pug">
.nav-bar-page
  .page
    router-link(to="/")
      h2 上海高职高专师资公共培训基地
    el-menu(
      v-if="this.$route.path != '/signUp' && this.$route.path != '/signIn'",
      background-color="#2f4157",
      active-text-color="#fff"
      text-color="#888"
      :default-active="$route.path"
      mode="horizontal")
      el-menu-item(index="/")
        router-link(to="/") 教学研究会
      el-menu-item(index="/train")
        router-link(to="/train")  培训平台
      el-menu-item(index="/competes")
        router-link(to="/competes")  比赛平台
      el-menu-item(index="/research/activities")
        router-link(to="/research/activities") 教改项目
      el-menu-item(index="/meeting/reserve")
        router-link(to="/meeting/reserve") 培训室预约
      el-menu-item(index="/videos")
        router-link(to="/videos") 资源展示
      el-menu-item(v-if="!auth", index="5")
        router-link(to="/signIn") 注册
      el-menu-item(v-if="!auth", index="6")
        router-link(to="/signUp") 登录
      el-menu-item(v-if="auth" index="8")
        el-dropdown(trigger="click")
          el-button {{ $store.state.userInfo.name || '用户名' }}
            i.el-icon-arrow-down
          el-dropdown-menu(slot="dropdown")
            el-dropdown-item(@click.native="onManagement" v-if="isSchoolAuth") 比赛信息
            el-dropdown-item(@click.native="onPage" v-else) 个人中心
            el-dropdown-item(@click.native="logout") 退出
</template>

<script>
export default {
  name: 'NavBar',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    isExpertAuth() {
      return this.$store.state.expertToken;
    },
    isUserAuth() {
      return this.$store.state.userToken;
    },
    isSchoolAuth() {
      return this.$store.state.schoolToken;
    },
    auth() {
      return this.isExpertAuth || this.isUserAuth || this.isSchoolAuth;
    },
  },
  methods: {
    async logout() {
      const loading = this.$loading({ fullscreen: true, text: '正在退出...' });
      if (this.isExpertAuth) {
        await this.$apis.expertInfo.logout();
        this.$store.commit('SET_EXPERT', '');
      } else {
        await this.$apis.userAuth.logout();
        this.$store.commit('SET_USER', '');
      }
      this.$store.commit('SET_USERINFO', {});
      loading.close();
      this.$router.push('/');
    },
    onManagement() {
      this.$router.push('/school/compete/activities');
    },
    onPage() {
      const url = this.isExpertAuth ? '/expert/center' : '/user';
      this.$router.push(url);
    },
  },
};
</script>

<style lang="stylus" scoped>
.nav-bar-page
  width 100%
  background #2f4157
  line-height 60px
  .page
    width 1170px
    display flex
    justify-content space-between
    align-items center
    margin 0px auto
  h2
    margin 0px
  a
    color #fff
  .el-menu
    border none
    .el-button
      color #fff
      background none
      border none

@media print
  .nav-bar-page
    display none
</style>



// WEBPACK FOOTER //
// NavBar.vue?367c7e35